import React from 'react'

import { useRoute } from '@react-navigation/native'
import { FlashList } from '@shopify/flash-list'

import { IMyTeamsEarningTransaction } from '../../api/earnings/types'
import ListEmptyComponent from './listEmptyComponent'
import ListFooter from './listFooter'
import TeamEarningsCard from './teamEarningsCard'

type Props = {
  data: IMyTeamsEarningTransaction[]
  onEndReached: () => void
  isFetchingNextPage: boolean
  onRefresh: () => void
  isFetching: boolean
}

const TeamEarningsList = ({
  data,
  onEndReached,
  isFetchingNextPage,
  onRefresh,
  isFetching,
}: Props) => {
  const { params }: { params: { earningType: string } } = useRoute<any>()
  return (
    <FlashList
      showsVerticalScrollIndicator={false}
      data={data}
      renderItem={({ item }) => (
        <TeamEarningsCard data={item} screenName={params?.earningType} />
      )}
      estimatedItemSize={114}
      ListEmptyComponent={isFetching ? <></> : <ListEmptyComponent />}
      ListFooterComponent={isFetchingNextPage ? <ListFooter /> : <></>}
      onEndReached={onEndReached}
      onEndReachedThreshold={0.5}
      onRefresh={onRefresh}
      refreshing={isFetching}
      keyExtractor={(item, index) =>
        String(item?.referenceId) + index.toString()
      }
    />
  )
}

export default TeamEarningsList
